import React, { memo } from "react";
import Icon from "../../../../components/Icon";
import useWindowResize from "../../../../hooks/useWIndowResize";
import iconPrice from '../../../../assets/images/icons/price-banner.svg';

const IntroPrice = ({ imageWidth, hasPromotion, ...rest }) => {
    const { isMobile } = useWindowResize();
    return (
        <>
            {!hasPromotion && (
                <div className="landing-intro__price-detail" {...rest}>
                    <span>
                        Protege el {isMobile && <br />}
                        lugar donde <br />
                        <b>hoy estas seguro</b>
                    </span>
                    <br />
                    <Icon name="price-banner" width={imageWidth} image={iconPrice} />
                </div>
            )}
        </>
    );
};

IntroPrice.defaultProps = {
    imageWidth: 121,
};

export default memo(IntroPrice);
